const webcastItemGroupingType = {
  ONE_MONEY: 1,
  PER_ITEM: 2,
  PER_LOT: 3
}

export default webcastItemGroupingType
